
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import colors from "../../resources/sass/_vars.scss"

ChartJS.register(ArcElement, Tooltip, Legend);
export const options = {
    plugins    : {
        legend: {
            display: false
        }
    }
}



export const data = {
    labels: ['Emails', 'Sms', 'Landings'],
    datasets: [
        {
            label: ' Entities',
            data: [0, 0, 0],
            backgroundColor: [
                colors.email,
                colors.sms,
                colors.landing,
            ],
            borderColor: [
                'rgb(255,255,255)',
                'rgb(255,255,255)',
                'rgb(255,255,255)',
            ],
            borderWidth: 1,
        },
    ],
};


const Creativities = (props) => {
    const emails = isNaN(parseInt(props?.data?.emails)) ? 0 : parseInt(props?.data?.emails)
    const landings = isNaN(props?.data?.landings) ? 0 : props?.data?.landings
    const sms = isNaN(props?.data?.sms) ? 0 : props?.data?.sms
    const total = emails + landings + sms



    data.datasets[0].data[0] = emails
    data.datasets[0].data[1] = sms
    data.datasets[0].data[2] = landings


    const round = (value, precision) => {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    }


    return (
        <div className="stats-doughnut">
            <div className="mb-3">
                <h6>Account Creativities</h6>
                <p>See percentages below</p>
            </div>

            {props.data && <Doughnut options={options} data={data} />}


            <ul className="stripped">
                <li>
                    <div className="item-history">
                        <span style={{backgroundColor: colors.sms}}></span>
                        Sms: {sms} ({round(parseInt(sms) * 100 / parseInt(total), 1)}%)
                    </div>
                </li>
                <li>
                    <div className="item-history">
                        <span style={{backgroundColor: colors.email}}></span>
                        Email: {emails} ({round(parseInt(emails) * 100 / parseInt(total), 1)}%)
                    </div>
                </li>
                <li>
                    <div className="item-history">
                        <span style={{backgroundColor: colors.landing}}></span>
                        Landing: {landings} ({round(parseInt(landings) * 100 / parseInt(total), 1)}%)
                    </div>
                </li>
            </ul>
        </div>
    )
}

export default Creativities;